import { createFileRoute } from "@tanstack/react-router";

import { parseSmsSearch } from "@/features/growth";
import { SmsLogPage } from "@/features/growth/pages";
import { ProblemError } from "@/shared/api/problem";
import { strictSearch } from "@/shared/lib/search";

/** The SMS log holds everybody's number: hg-notify gives it to a superadmin alone. */
export const Route = createFileRoute("/_app/growth/messages/")({
  beforeLoad: ({ context }) => {
    if (context.role !== "superadmin") {
      throw new ProblemError({ status: 403, code: "forbidden", title: "Forbidden" });
    }
  },
  validateSearch: strictSearch(parseSmsSearch),
  component: SmsLog,
});

function SmsLog() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SmsLogPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
